import script from "./HotelSearchPage.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelSearchPage.vue?vue&type=script&setup=true&lang=js"

import "./HotelSearchPage.vue?vue&type=style&index=0&id=4138d3ba&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4138d3ba"]])

export default __exports__